import { format as formatFns } from 'date-fns';
import { sv } from 'date-fns/locale';

export const dateTimeFormat = {
  YearMonth: 1,
  DayMonth: 2,

  format: (value: string | Date, format: number) => {
    const date = new Date(value);
    switch (format) {
      case dateTimeFormat.YearMonth:
        return formatFns(date, 'MMMM yyyy', { locale: sv });
      case dateTimeFormat.DayMonth:
        return formatFns(date, 'd MMMM yyyy', { locale: sv });
      default:
        return formatFns(date, 'yyyy-MM-dd HH:mm', { locale: sv });
    }
  },
};
